import { HttpClient } from "../HttpClient";
/**
 * * Get Asset Label
 */
export const GetFavoriteAssetLabel = async (userid) => {
	try {
		const { data } = await HttpClient.get("api/favoriteassetlabels", {
			params: {
				id: userid
			},
		});

		return await Promise.resolve(data);

	} catch (err) {
		return Promise.reject(err);
	}
};
